
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const footerLinks = [
    { label: 'Servicios', id: 'servicios' },
    { label: 'Proceso', id: 'proceso' },
    { label: 'Testimonios', id: 'testimonios' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contacto', id: 'contacto' }
  ];

  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Logo */}
          <h3 className="text-2xl font-bold mb-8 font-outfit">
            NeatWave Services LLC
          </h3>
          
          {/* Navigation Links */}
          <nav className="mb-8">
            <ul className="flex flex-wrap justify-center gap-8">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-slate-300 hover:text-white transition-colors font-medium cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
          
          {/* Copyright */}
          <div className="pt-8 border-t border-slate-700 text-slate-400 text-sm">
            <p>&copy; 2025 NeatWave Services LLC. Todos los derechos reservados.</p>
            <p className="mt-2">
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
